// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageAdmins_overlayWrapper__mXhLj","viewBox":"ManageAdmins_viewBox__HWnN1","tablestyle":"ManageAdmins_tablestyle__LLCsR"};